<template>
  <div>
    <navigation></navigation>
    <div class="about text-left mx-auto" style="max-width: 900px">
      <h3 class="text-center">News</h3>
      <p></p>
      <div class="card" style="width: 100%">
        <div class="card-body">
          <h5 class="card-title">MONO, 26.06 – 30.08.2020</h5>
          <p class="card-text">
            H.G. GRIESE + HOLGER JOHN canvas + paper<br />
            VERNISSAGE Freitag, 26.06. 2020 19 Uhr, Wort: John Hinnerk Pahl
          </p>
          <a
            href="http://www.galerie-holgerjohn.de/"
            target="new"
            class="card-link"
            ><i class="fa fa-external-link"></i> www.galerie-holgerjohn.de</a
          >
        </div>
        <div class="card-footer">
          <small class="text-muted"
            ><i class="fa fa-map-marker"></i>
            Rähnitzgasse 17, 01097 Dresden
          </small>
        </div>
      </div>
    </div>
    <back-to-top bottom="20px" right="20px">
      <button type="button" class="btn btn-light btn-to-top">
        <i class="fa fa-chevron-up"></i>
      </button>
    </back-to-top>
  </div>
</template>

<script>
import navigation from "@/components/navigation.vue";
export default {
  components: {
    navigation,
  },
};
</script>

<style lang="scss">
@import "./../sass/_main.scss";
</style>
